<template>
  <div class="app-page-container">
  <headerBar :gameID="$store.state.gameID"></headerBar>

    <div class="app-body main-container">
       <div class="account-info">
      
        <div class="info-line">
          <span class="title"> {{ $t("common.game") }}</span>
          <span class="info">{{ $store.state.gameName }}</span>
        </div>
        <div class="info-line">
          <span class="title">{{ $t("common.playerId") }}</span>
          <span class="info">{{ $store.state.aid }}</span>
        </div>
      </div>

       <div class="step-bar-bg">
      <div class="faq-list">
       
        <div class=" faq-title"> <span class="icon_faq"></span>{{$t("faq.title")}}</div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(1)">{{$t("faq.q1")}}</div>
        <div class="answer" :class="{ showAnswer: flag === 1 }">
           {{$t("faq.a1-1")}} <a v-omnisdk_open href="https://www.mattel163.com/eula.html#p1" target="_blank"> {{$t("faq.a1-2")}} </a>{{$t("faq.a1-0")}}{{$t("common.point")}}
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(2)">
          {{$t("faq.q2")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 2 }">
          {{$t("faq.a2")}}
          <a v-omnisdk_open href="https://www.mattel163.com/privacypolicy.html" target="_blank">{{$t("faq.a1-2")}}</a>
          {{$t("faq.a2-0")}}
          {{$t("common.point")}}
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(3)">
         {{$t("faq.q3")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 3 }">
          {{$t("faq.a3")}}
          <a v-omnisdk_open href="https://www.mattel163.com/privacypolicy.html" target="_blank"
            >{{$t("faq.a16-2")}}</a
          >{{$t("faq.a3-0")}}{{$t("common.point")}}
        </div>
      </div>
    
      <div class="faq-list">
        <div class="question" @click="toggle(4)">
      {{$t("faq.q4")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 4 }">
         {{$t("faq.a4-1")}} <a v-omnisdk_open href="https://www.mattel163.com/privacypolicy.html" target="_blank">{{$t("faq.a16-2")}}</a>,{{$t("faq.a4-2")}}
          <a v-omnisdk_open href="mailto:mgs-dataprivacy@mattel.com">mgs-dataprivacy@mattel.com</a>{{$t("common.point")}} 
          <!-- {{$t("faq.a4-3")}} -->
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(5)">
          {{$t("faq.q5")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 5 }">
        <p>  {{$t("faq.a5-1")}}
          <a
            href="javascript:void(0)"
            @click="judgeJump"
            > {{$t("faq.a5-2")}}</a
          >{{$t("common.point")}} </p>
          <p> {{$t("faq.a5-3")}}  </p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(6)">
        {{$t("faq.q6")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 6 }">
         <p>
             {{$t("faq.a6")}}
         </p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(7)">
        {{$t("faq.q7")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 7 }">
         <p>   {{$t("faq.a7-1")}}
          <a href="javascript:void(0)" @click="$router.push({ name: 'Home' })"
            > {{$t("faq.a7-2")}}</a
          >{{$t("common.point")}}</p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(8)">
        {{$t("faq.q8")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 8 }">
          <p>  {{$t("faq.a8")}}</p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(9)">
        {{$t("faq.q9")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 9 }">
         
          <p>	 {{$t("faq.a9")}} <a v-omnisdk_open href="https://www.mattel163.com/privacypolicy.html" target="_blank"> https://www.mattel163.com/privacypolicy.html</a>{{$t("faq.a9-0")}}{{$t("common.point")}}</p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(10)">
         {{$t("faq.q10")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 10 }">
          <p>	 {{$t("faq.a10-1")}} <a href="javascript:void(0)" @click="$router.push({ name: 'Home'})">{{$t("faq.a10-2")}}</a>  {{$t("faq.a10-3")}}</p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(11)">
         {{$t("faq.q11")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 11 }">
          <p>	{{$t("faq.a11-1")}}
          <strong>
             {{$t("faq.a11-2")}}</strong
          >{{$t("common.point")}}</p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(12)">
         {{$t("faq.q12")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 12 }">
        <p> 	{{$t("faq.a12")}}
          <a href="javascript:void(0)" @click="judgeJump"> {{$t("faq.a12-2")}}</a>	{{$t("faq.a12-0")}}{{$t("common.point")}}</p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(13)">
        {{$t("faq.q13")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 13 }">
         <p>	{{$t("faq.a13")}}</p>
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(14)">
         {{$t("faq.q14")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 14 }">
          <p>	{{$t("faq.a14")}} <a v-omnisdk_open href="https://www.mattel163.com/support">{{ 'https://www.mattel163.com/support' }}</a></p>
          <!-- <p>	{{$t("faq.a14")}} <a :href="mail">{{$store.state.serviceMail}}</a> {{$t("faq.a14-15-16-0")}}{{$t("common.point")}}</p> -->
        </div>
      </div>
      <div class="faq-list">
        <div class="question" @click="toggle(16)">
          {{$t("faq.q16")}}
        </div>
        <div class="answer" :class="{ showAnswer: flag === 16 }">
          {{$t("faq.a16-1")}}
          <a v-omnisdk_open href="https://www.mattel163.com/privacypolicy.html" target="_blank"
            >{{$t("faq.a16-2")}}</a
          >, {{$t("faq.a16-3")}}
          <a v-omnisdk_open href="mailto:mgs-dataprivacy@mattel.com">mgs-dataprivacy@mattel.com</a>{{$t("faq.a14-15-16-0")}}{{$t("common.point")}}
        </div>
      </div>
      </div>
    </div>
    <description></description>
    <footerBar :activeIndex="1" @showLanguage="showLanguage"></footerBar>
  </div>
</template>
<script>
import headerBar from "../components/common/header_new";
import footerBar from "../components/common/footer";
import description from "../components/common/description";
export default {
  data() {
    return {
      flag: 0,
    };
  },
  components: {
    headerBar,
    footerBar,
    description,
  },
  mounted(){
    this.verify();
  },
   computed:{
    mail(){
      return 'mailto:' + this.$store.state.serviceMail;
    }
  },
  methods: {
      showLanguage(){
      this.$emit('showLanguage')
    },
    toggle(index) {
      this.flag = this.flag === index ? 0 : index;
    },
      verify  () {
  const _this = this;
  // 验证token是否通过
   _this.$axios({
      method: "post",
      url: "/privacy/token/verify",
      data: {
        pinToken: _this.$cookie.get("token"),
        ua:navigator.userAgent || ''
      },
    })
    .then((res) => {
      if (res.status === 200 && res.data && res.data.r) {
        _this.tore.state.aid = res.data.r.aid;
         _this.store.state.pin = res.data.r.pin;
         _this.store.state.gameID = res.data.r.gameID;
         _this.store.state.gameName = res.data.r.name;
         _this.store.state.taskExist = res.data.r.taskExist; //是否已经创建过删除任务
         _this.store.state.dataExist = res.data.r.dataExist; //是否已经创建过删除任务
         _this.store.state.canCancel = res.data.r.canCancel; //是否可以取消
         _this.store.state.ctime = res.data.r.ctime; //是否可以取消
         _this.store.state.lastCancelTime = res.data.r.lastCancelTime ? res.data.r.lastCancelTime :0; //是否可以取消
         _this.$store.state.doNotSell = res.data.r.doNotSell;
        // _this.$router.push({ name: "Home" });
      }
    })
    .catch((err) => {
      console.log(err)
    });
},
    judgeJump(){
      // $router.push({ name: 'BeforeDel' })
      if(this.$store.state.taskExist){
        this.$router.push({ name: 'DeletePend' })
      }else if(this.$store.state.pendFlag  || this.$store.state.requestDataState === 1){
          this.$router.push({ name: 'forbiddenRequest' })
      }else{
        this.$router.push({ name: 'BeforeDel' })
      }
    }
  },
};
</script>
<style lang="less" scoped>
a{
  word-wrap: break-word;
    word-break: break-all;
}
// .title {
//      padding-top: 1rem;
//   margin-bottom: 0.25rem;
//   font-weight: 700;
//   margin-bottom: 0.25rem;
//   font-size: .56rem;
// }
.app-body{
  overflow-y: hidden;
}
.step-bar-bg{
   background: #F1F1F1 ;
      border-radius: 0.32rem;
      padding: 0.42rem;
      margin-bottom: 0.42rem;
      padding-top: 0;
      overflow-y: auto;
      height: calc(100% - 1rem);
}

.faq-list {

  width: 100%;
  border-bottom: 1px solid #D9D9D9;
  .faq-title{
    font-size: 0.48rem;
    font-weight: 700;
    padding:  0.4rem 0;
    display: flex;
    align-items: center;
      .icon_faq{
        display: inline-block;
        width: 0.8rem;
        height: 0.8rem;
        background:url('../assets/ic_faq.png') center center no-repeat ;
        background-size: 100% 100%;
        margin-right: 0.1rem;
      }

  }
  .question {
    padding: 0.4rem 0;
    font-weight: 700;
    font-size: .37rem;
  }
  .answer {
    overflow: hidden;
    transition: max-height 0.15s ease-out;
    max-height: 0;
    font-size: 0.32rem;
    margin-bottom: 5px;
    text-decoration: none;
  }
  .showAnswer {
    &.answer {
      // padding-top: 10px;
      padding-bottom: 10px;
      transition: max-height 0.15s ease-in;
      max-height: 2000px;
    }
  }
}

.account-info{
  display: none;
}



@media screen and (orientation: landscape) {

 .account-info {
    display: block !important;
    position: absolute;
    left: 20%;
    width: 40%;
    color: #ffffff;
    border: none !important;
    box-shadow: none !important;
    transform: translateX(-50%);
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    top: 0;
    .info-line {
     margin: 0.32rem 0;
      display: flex;
      padding: 0 0.64rem;
      display: flex;
      word-break: break-all;
      .title {
        flex: 1;
        color: #ffffff !important;
        font-weight: normal !important;
        text-align: left;
        font-size: 0.42rem;
        min-width: 25%;
      }
      .info {
        margin-left: 0.2rem;
        color: #ffffff !important;
        flex: 2;
        font-size: 0.42rem;
        color: #262626;
        font-weight: 700;
      }
    }
  }
}
</style>